import React from 'react';
import styled from 'styled-components';

interface FloatingLayoutProps {
  children: React.ReactNode;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  hideOnMobile?: boolean;
  className?: string;
}

const FloatingContainer = styled.div<{ 
  $position: string; 
  $hideOnMobile: boolean;
}>`
  position: fixed;
  z-index: 1000;
  max-width: 400px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.radii.scale[2]};

  ${({ $position, theme }) => {
    switch ($position) {
      case 'bottom-right':
        return `
          bottom: ${theme.space.spacing20};
          right: ${theme.space.spacing20};
        `;
      case 'bottom-left':
        return `
          bottom: ${theme.space.spacing20};
          left: ${theme.space.spacing20};
        `;
      case 'top-right':
        return `
          top: ${theme.space.spacing20};
          right: ${theme.space.spacing20};
        `;
      case 'top-left':
        return `
          top: ${theme.space.spacing20};
          left: ${theme.space.spacing20};
        `;
      default:
        return `
          bottom: ${theme.space.spacing20};
          right: ${theme.space.spacing20};
        `;
    }
  }}

  ${({ $hideOnMobile }) => $hideOnMobile && `
    @media (max-width: 768px) {
      display: none;
    }
  `}
`;

export const FloatingLayout: React.FC<FloatingLayoutProps> = ({ 
  children, 
  position = 'bottom-right',
  hideOnMobile = false,
  className 
}) => (
  <FloatingContainer 
    $position={position} 
    $hideOnMobile={hideOnMobile}
    className={className}
  >
    {children}
  </FloatingContainer>
);

FloatingLayout.displayName = 'FloatingLayout';